<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "InformasiEvent",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
